import { HtmlEntityType } from '../enums/HtmlEntityType';

export const DEFAULT_PLACEHOLDER_LABEL = HtmlEntityType.Dash;
